<template>
    <el-dialog
        :title="detailsDialogTitle"
        :visible.sync="receivableDetailsVisible"
        width="800px"
        :before-close="handleDetailDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="false"
        custom-class="custom-form-dialog custom-receivable-detail_dialog"
    >
        <div class="page_little_title">{{ receivableDetails.source_type == "order" ? "订单信息" : "基本信息" }}</div>
        <template v-if="receivableDetails.source_type == 'order'">
            <el-form label-position="top" size="small">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="关联订单">
                            <div>
                                <el-link
                                    type="primary"
                                    v-text="receivableDetails.basic_info.order_no"
                                    :underline="false"
                                    @click="handleClickOrderDetail"
                                >
                                </el-link>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="客户联系人">
                            <div
                                v-text="
                                    receivableDetails.basic_info.customer_contact_info &&
                                    receivableDetails.basic_info.customer_contact_info.name
                                "
                            ></div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="订单总金额">
                            <div
                                v-text="
                                    Number(receivableDetails.basic_info.order_amount).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                "
                            ></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="销售">
                            <div
                                v-text="
                                    receivableDetails.basic_info.salesperson_info &&
                                    receivableDetails.basic_info.salesperson_info.name
                                "
                            ></div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <template v-else>
            <el-form label-position="top" size="small">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="应收编号">
                            <div v-text="receivableDetails.receivable_info.receivable_no"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="供应商名称">
                            <div v-text="receivableDetails.basic_info.supplier_name"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="采购编号">
                            <el-link
                                type="primary"
                                v-text="receivableDetails.basic_info.purchase_refund_no"
                                :underline="false"
                                @click="handleClickRelateId(receivableDetails.basic_info.purchase_id)"
                            >
                            </el-link>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="审批编号">
                            <el-link
                                type="primary"
                                v-text="receivableDetails.basic_info.approval_id"
                                :underline="false"
                                @click="handleClickApprovalDetail(receivableDetails.basic_info.approval_id)"
                            >
                            </el-link>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="申请人">
                            <div
                                v-text="
                                    receivableDetails.basic_info &&
                                    receivableDetails.basic_info.uid_info &&
                                    receivableDetails.basic_info.uid_info.name
                                "
                            ></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="申请日期">
                            <div v-text="receivableDetails.basic_info.apply_time"></div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <template v-if="receivableDetails.source_type == 'order'">
            <div class="page_little_title">回款信息</div>
            <el-form label-position="top" size="small">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="回款公司">
                            <div v-text="receivableDetails.basic_info.payment_company_name"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="回款日期">
                            <div v-text="receivableDetails.basic_info.payment_date"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="回款方式">
                            <div v-text="receivableDetails.basic_info.payment_method_name"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="本次回款金额">
                            <div
                                v-text="
                                    Number(receivableDetails.basic_info.payment_amount).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                "
                            ></div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <div
                                class="text_bg"
                                v-if="receivableDetails.basic_info && receivableDetails.basic_info.remark"
                                v-text="receivableDetails.basic_info.remark"
                            ></div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="附件">
                            <div
                                class="file_upload_wrap"
                                v-if="
                                    receivableDetails.basic_info.attachments &&
                                    receivableDetails.basic_info.attachments.length
                                "
                            >
                                <ul class="upload_file_list upload_file_list_detail">
                                    <li
                                        v-for="file in receivableDetails.basic_info.attachments"
                                        class="upload_file_item"
                                    >
                                        <div class="file_left_wrap">
                                            <img
                                                alt=""
                                                class="file_img"
                                                src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                            />
                                            <div class="file_info_wrap">
                                                <p class="file_name" v-text="file.file_name"></p>
                                                <p class="file_size" v-text="file.file_size"></p>
                                            </div>
                                        </div>
                                        <div class="file_right_wrap">
                                            <el-tooltip content="预览" effect="dark" placement="top">
                                                <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                    <i class="iconfont icon-yanjing"></i>
                                                </span>
                                            </el-tooltip>
                                            <span class="line"></span>
                                            <el-tooltip content="下载" effect="dark" placement="top">
                                                <span class="handle_icon_wrap" @click="handleClickDownloadFile(file)">
                                                    <i class="iconfont icon-daochu"></i>
                                                </span>
                                            </el-tooltip>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <div class="page_little_title">金额信息</div>
        <el-form label-position="top" size="small">
            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="应收款金额">
                        <div
                            v-text="
                                Number(receivableDetails.receivable_info.receivable_amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            "
                        ></div>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="receivableDetails.receivable_info.status == 2">
                    <el-form-item label="已确认金额">
                        <div
                            v-text="
                                Number(receivableDetails.receivable_info.confirmed_amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            "
                        ></div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <template v-if="receivableDetails.other_info.reject_time">
            <div class="page_little_title">其他信息</div>
            <el-form label-position="top" size="small">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="驳回时间">
                            <div>{{ receivableDetails.other_info.reject_time }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="驳回原因">
                            <div
                                class="text_bg"
                                v-if="receivableDetails.other_info && receivableDetails.other_info.reject_reason"
                            >
                                {{ receivableDetails.other_info.reject_reason }}
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <template v-if="receivableDetails.receivable_info.status == 2">
            <!-- 只有已确认和已作废的显示财务信息 -->
            <div class="page_little_title">其他信息</div>
            <el-form label-position="top" size="small">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <div v-text="receivableDetails.receivableConfirmationsRemark && receivableDetails.receivableConfirmationsRemark.remark"></div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="收款凭证">
                            <div>
                                <ul class="voucher_list" v-if="receivableDetails.receivableConfirmationsRemark && receivableDetails.receivableConfirmationsRemark.voucher.length">
                                    <li :key="index" class="voucher_item" v-for="(item, index) in receivableDetails.receivableConfirmationsRemark.voucher">
                                        <el-image
                                            :preview-src-list="receivableDetails.receivableConfirmationsRemark.voucher"
                                            :src="item"
                                            alt=""
                                            style="max-width: 32px; max-height: 32px"
                                        ></el-image>
                                    </li>
                                </ul>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <template v-if="receivableDetails.other_info.invalid_time">
            <div class="page_little_title">作废信息</div>
            <el-form label-position="top" size="small">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="作废时间">
                            <div>{{ receivableDetails.other_info.invalid_time }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="作废原因">
                            <div
                                class="text_bg"
                                v-if="receivableDetails.other_info && receivableDetails.other_info.invalid_reason"
                            >
                                {{ receivableDetails.other_info.invalid_reason }}
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>

        <PurchaseDetail
            :purchaseDetailVisible.sync="purchaseDetailVisible"
            v-if="purchaseDetailVisible"
            :purchaseId="purchaseId"
        />

        <el-image
            :preview-src-list="previewImgList"
            :src="previewImgSrc"
            ref="preview_img"
            style="display: none"
        ></el-image>
    </el-dialog>
</template>
<script>
import { ReceivableDetail } from "@/api";
import PurchaseDetail from "../../../Purchase/component/purchase_detail.vue"; //采购详情
import { getOSSData } from "@/utils/uploadOss";

export default {
    name: "ReceivableDetails",
    props: {
        receivableDetailsVisible: {
            type: Boolean,
            default: false,
        },
        receivable_no: {
            type: String,
            default: "",
        }, // 应收编号
    },
    components: { PurchaseDetail },
    computed: {
        detailsDialogTitle() {
            let title = "应收详情";
            if (this.receivableDetails.receivable_info.status == 2) {
                // 已确认
                title = "已确认详情";
                if (this.receivableDetails.other_info && this.receivableDetails.other_info.invalid_time) {
                    title = "已作废详情";
                }
            } else if (this.receivableDetails.other_info && this.receivableDetails.other_info.reject_time) {
                title = "驳回详情";
            }
            return title;
        },
    },
    data() {
        return {
            receivableDetails: {
                source_type: "",
                basic_info: {}, // 订单信息
                receivable_info: {}, // 财务信息
                other_info: {}, // 驳回信息 或 作废信息
                receivableConfirmationsRemark: {}, // 财务的其他信息
            },

            purchaseId: null,
            purchaseDetailVisible: false, //采购详情

            previewImgList: [],
            previewImgSrc: "",
        };
    },
    created() {
        if (this.receivable_no) {
            this.getReceivableDetail();
        }
    },
    methods: {
        handleDetailDialogClose() {
            this.$emit("update:receivableDetailsVisible", false);
        },
        // 应收详情
        getReceivableDetail() {
            ReceivableDetail({ receivable_no: this.receivable_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.receivableDetails = data;
                }
            });
        },
        // 采购详情
        handleClickRelateId(purchaseId) {
            this.purchaseId = purchaseId;
            this.purchaseDetailVisible = true;
        },
        // 审批详情
        handleClickApprovalDetail(approval_id) {
            this.$showApprovalDetail({
                approval_id,
            }).then((res) => {});
        },
        // 去付款
        handleClickPayable() {},
        //查看订单详情
        handleClickOrderDetail() {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: this.receivableDetails.basic_info.order_no,
                    name: this.receivableDetails.basic_info.order_no,
                    query_type: "order_no",
                },
            });
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
    },
};
</script>
<style lang="scss">
.mb_24 {
    margin-bottom: 24px;
}
.custom-receivable-detail_dialog {
    .el-dialog__body {
        max-height: 660px;
        overflow-y: auto;
    }
    .voucher_list {
        display: flex;
        gap: 8px;
        .voucher_item {
            width: 48px;
            height: 48px;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 48px;
            border-radius: 4px;

            .el-image {
                max-width: 100%;
                max-height: 100%;
            }

            img {
                max-width: 100%;
                max-height: 100%;
                object-fit: cover;
            }

            .icon-jianqu {
                position: absolute;
                right: -8px;
                top: -8px;
                cursor: pointer;
                font-size: 16px;
                color: rgba(255, 77, 79, 1);
                line-height: 16px;
            }
        }
    }
    .el-form {
        .el-form-item__label {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(153, 153, 153, 1);
        }
        .text_bg {
            padding: 8px 12px;
            line-height: 22px;
            border-radius: 6px;
            background: rgba(237, 240, 244, 1);
        }
        .el-link {
            display: inline;
        }
    }
    .total_payment {
        width: 100%;
        padding: 8px 12px;
        border-radius: 6px 6px, 0px, 0px;
        background: rgba(237, 240, 244, 1);
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
            margin-right: 24px;
        }
    }
    .el-form {
        .el-row {
            .el-link--primary {
                display: block;
            }
        }
    }
}
</style>
